import { useCallback } from "react";
import { apolloClient } from "@td/ui";
import MEMBERS_SEARCH_QUERY from "../queries/members-search.graphql";
import { maskMemberRecord } from "../utils/masking";

const useMemberSearch = () => {
  const findMember = useCallback(async (memberId) => {
    try {
      const { data: { membersSearch: { activeMembers }}} = await apolloClient.query({
        query: MEMBERS_SEARCH_QUERY,
        variables: {
          searchParams: {
            memberId: parseInt(memberId),
          },
          exactSearch: true,
        },
        fetchPolicy: "network-only",
      });

      return maskMemberRecord(activeMembers && activeMembers[0]);
    } catch (e) {
      return null;
    }
  }, [apolloClient]);

  return {
    findMember,
  };
};

export default useMemberSearch;
